// extracted by mini-css-extract-plugin
export default {"container":"nav_item_group-module__container--3yZLc"};